// ./src/components/generic/TaxSelect/taxRows.ts
//
// ROADMAP A2e #78 — the rows `TaxSelect` offers, on their own so the guard runs them.
import { upsertBy } from "@em/utils";
import type { TaxSetting } from "@/utils/api";

/**
 * The caller's rows plus the rates created from this picker, each once. ⚠ Without the created ones a rate made in place
 * is selected but not in the list, so the field reads blank: a caller that passes `taxSettings` owns that list, and the
 * drawer's own provider never reloads it. A later reload that already carries a created rate does not list it twice.
 */
export const withCreatedTaxes = (rows: TaxSetting[], created: TaxSetting[]): TaxSetting[] => {
  const seen = new Set(rows.map((tax) => tax.id));

  return [...rows, ...created.filter((tax) => tax.id && !seen.has(tax.id))];
};

/**
 * The list after `saved` was stored. ⚠ ONE default per account: the server takes it from every other rate when one is
 * saved as the default, so the list must too — or two rows show the "Default" badge until the next reload.
 */
export const withSavedTax = (rows: TaxSetting[], saved: TaxSetting): TaxSetting[] =>
  upsertBy(saved.isDefault ? rows.map((row) => (row.id !== saved.id && row.isDefault ? { ...row, isDefault: false } : row)) : rows, saved, "id");
